import { UserPermissionEnum } from "../../user-management/enum/user-permision.enum";


export class AuthenticationDialog{
    callbackFunction : any;
    selfAuthentication : boolean;
    permission: UserPermissionEnum;
    username: string;
    password: string;

    constructor(callbackFunction:any,permission: UserPermissionEnum, selfAuthentication: boolean){
        this.callbackFunction = callbackFunction;
        this.permission = permission;
        this.selfAuthentication = selfAuthentication;
    }
}